interface GoogleConfig {
  /** OAuth Client ID (GIS) — nunca secret no browser. */
  CLIENT_ID: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface MercadoPagoConfig {
  /** Public Key só no browser — nunca Access Token (DOC 02 § 4.5.2). */
  publicKey: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
  mercadopago: MercadoPagoConfig;
}

// Base da API versionada (DOC 06 / 09). Fallback = Docker Compose local.
const apiBase =
  process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "https://localhost";

const config: Config = {
  google: {
    CLIENT_ID: (process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim(),
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: apiBase.endsWith("/api/v1") ? apiBase : `${apiBase}/api/v1`,
  },
  mercadopago: {
    publicKey: (process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY || "").trim(),
  },
};

export default config;
